/**
 * A/B Testing Event Tracker - v2
 * Tracks page views and add-to-cart events with full AB test context.
 * Variant assignment comes from metafield + URL handle.
 * Deduplicates ATC events (Kaching fires both form + fetch).
 */
(function() {
  'use strict';

  const CONFIG = {
    firebase: {
      apiKey: "AIzaSyBnCAHn6lJsu4jtVSpQXuP40c8KCiXHG4s",
      projectId: "shopify-abtest"
    },
    debug: true,
    atcDedupeWindowMs: 2000
  };

  function log(...args) {
    if (CONFIG.debug) console.log('[AB-Track]', ...args);
  }

  // ── Visitor ID ──
  function getVisitorId() {
    const cookieName = '_ab_vid';
    const v = `; ${document.cookie}`;
    const p = v.split(`; ${cookieName}=`);
    let id = p.length === 2 ? p.pop().split(';').shift() : null;
    if (!id) {
      id = 'v_' + Math.random().toString(36).substr(2, 16) + Date.now().toString(36);
      const d = new Date();
      d.setTime(d.getTime() + 365 * 86400000);
      document.cookie = `${cookieName}=${id};expires=${d.toUTCString()};path=/;SameSite=Lax`;
      log('New visitor:', id);
    }
    return id;
  }

  // ── AB Test context from metafield script tag ──
  var _abTestInfo = null;
  function getABTestInfo() {
    if (_abTestInfo) return _abTestInfo;
    _abTestInfo = {};
    try {
      // The metafield is rendered as a console.log in a <script> tag
      var scripts = document.querySelectorAll('script');
      for (var i = 0; i < scripts.length; i++) {
        var txt = scripts[i].textContent;
        if (txt && txt.indexOf('ab_testing.active_test') !== -1) {
          // Extract the JSON object after the comma in console.log(...)
          var match = txt.match(/ab_testing\.active_test[^,]*,\s*(\{[\s\S]*?\})\s*\)/);
          if (match && match[1]) {
            var testData = JSON.parse(match[1]);
            _abTestInfo.testId = testData.id || '';
            _abTestInfo.testName = testData.name || '';
            // Determine which variant this page is by matching the URL handle
            var path = window.location.pathname;
            if (testData.variants && testData.variants.length) {
              for (var v = 0; v < testData.variants.length; v++) {
                var variant = testData.variants[v];
                if (variant.handle && path.indexOf(variant.handle) !== -1) {
                  _abTestInfo.abVariantName = variant.name;
                  _abTestInfo.abVariantWeight = String(variant.weight);
                  break;
                }
              }
              // If no variant matched the URL, this is the original/control product
              if (!_abTestInfo.abVariantName) {
                _abTestInfo.abVariantName = 'control';
              }
            }
          }
          break;
        }
      }
    } catch(e) { log('Error parsing AB test metafield:', e); }

    // Fallback: extract from URL if on a shadow product page
    // URL pattern: /products/...-ab-{testId}-{variantName}-{hash}
    if (!_abTestInfo.testId) {
      try {
        var urlMatch = window.location.pathname.match(/-ab-([a-f0-9]{8})-([a-z]+-[a-z]+)-[a-z0-9]+/i);
        if (urlMatch) {
          _abTestInfo.testId = urlMatch[1];
          _abTestInfo.abVariantName = urlMatch[2];
          log('Extracted from URL:', _abTestInfo.testId, _abTestInfo.abVariantName);
        }
      } catch(e2) { log('Error parsing URL for AB info:', e2); }
    }

    return _abTestInfo;
  }

  // ── Store/country from page context ──
  function getStoreInfo() {
    var info = {};
    try {
      info.storeDomain = window.Shopify?.shop || window.location.hostname;
      // Extract country from kaching-bundles-config if available
      var kcConfig = document.getElementById('kaching-bundles-config');
      if (kcConfig) {
        var cfg = JSON.parse(kcConfig.textContent);
        if (cfg.country) info.country = cfg.country;
        if (cfg.shopifyDomain) info.shopDomain = cfg.shopifyDomain;
      }
      // Fallback: extract country hint from domain (lumia-pl -> PL)
      if (!info.country) {
        var m = info.storeDomain.match(/lumia-([a-z]{2})\./i);
        if (m) info.country = m[1].toUpperCase();
      }
    } catch(e) {}
    return info;
  }

  // ── Kaching deal/offer info ──
  function getKachingInfo() {
    var info = {};
    try {
      var sid = localStorage.getItem('kaching_session_id');
      if (sid) info.kachingSessionId = sid;
    } catch(e) {}

    // Read deal-block data from Kaching elements (data-* attributes on .kaching-bundles__block)
    try {
      var block = document.querySelector('.kaching-bundles__block--loaded, [data-deal-block-id]');
      if (block) {
        var abVarId = block.getAttribute('data-ab-test-variant-id') || block.dataset.abTestVariantId;
        var abVar = block.getAttribute('data-ab-test-variant') || block.dataset.abTestVariant;
        var dealBlockId = block.getAttribute('data-deal-block-id') || block.dataset.dealBlockId;
        if (abVarId) info.kachingVariantId = abVarId;
        if (abVar) info.kachingVariant = abVar;
        if (dealBlockId) info.kachingDealBlockId = dealBlockId;
      }
      // Fallback: old custom element format
      if (!info.kachingVariantId) {
        var selectors = ['kaching-bundles-sticky-atc[deal-block]', 'kaching-bundle[deal-block]', 'kaching-bundle-deals[deal-block]'];
        for (var s = 0; s < selectors.length; s++) {
          var el = document.querySelector(selectors[s]);
          if (el) {
            var db = JSON.parse(el.getAttribute('deal-block'));
            if (db.abTestVariantId) info.kachingVariantId = db.abTestVariantId;
            if (db.abTestVariantNumber != null) info.kachingVariantNum = String(db.abTestVariantNumber);
            break;
          }
        }
      }
    } catch(e) {}

    // Detect which deal bar is selected (single, BOGO, triple, etc.)
    try {
      var selected = document.querySelector('.kaching-bundles__bar--selected');
      if (!selected) selected = document.querySelector('kaching-bundle-deal-bar[selected], [data-selected="true"], .kaching-selected');
      if (selected) {
        var title = selected.querySelector('.kaching-bundles__bar-title')?.textContent?.trim()
          || selected.getAttribute('title')
          || selected.querySelector('[class*="title"]')?.textContent?.trim();
        if (title) info.selectedOffer = title;
        var barId = selected.getAttribute('data-deal-bar-id') || selected.dataset?.dealBarId;
        if (barId) info.kachingDealBarId = barId;
      }
    } catch(e) {}

    return info;
  }

  // ── ATC deduplication ──
  var _lastAtc = { productId: null, time: 0 };
  function isDuplicateAtc(productId) {
    var now = Date.now();
    if (_lastAtc.productId === productId && (now - _lastAtc.time) < CONFIG.atcDedupeWindowMs) {
      log('Skipping duplicate ATC for product', productId);
      return true;
    }
    _lastAtc = { productId: productId, time: now };
    return false;
  }

  // ── Send event to Firebase ──
  function trackEvent(eventType, data) {
    data = data || {};
    var visitorId = getVisitorId();
    var docId = visitorId + '_' + Date.now();
    var baseUrl = 'https://firestore.googleapis.com/v1/projects/' + CONFIG.firebase.projectId + '/databases/(default)/documents';

    // Merge AB test info + store info into metadata
    var abInfo = getABTestInfo();
    var storeInfo = getStoreInfo();
    var allMeta = Object.assign({}, storeInfo, abInfo, data);

    // Build Firestore field map for metadata
    var metaFields = {};
    Object.keys(allMeta).forEach(function(k) {
      if (allMeta[k] != null && allMeta[k] !== '') {
        metaFields[k] = { stringValue: String(allMeta[k]) };
      }
    });

    var payload = {
      fields: {
        visitorId: { stringValue: visitorId },
        eventType: { stringValue: eventType },
        timestamp: { stringValue: new Date().toISOString() },
        url: { stringValue: window.location.href },
        metadata: { mapValue: { fields: metaFields } }
      }
    };

    // Top-level fields for easier querying
    var productId = window.ShopifyAnalytics?.meta?.product?.id
      || document.querySelector('meta[name="product-id"]')?.content;
    if (productId) payload.fields.productId = { stringValue: String(productId) };
    if (abInfo.testId) payload.fields.testId = { stringValue: abInfo.testId };
    if (abInfo.abVariantName) payload.fields.variantId = { stringValue: abInfo.abVariantName };
    if (storeInfo.storeDomain) payload.fields.storeDomain = { stringValue: storeInfo.storeDomain };
    if (storeInfo.country) payload.fields.country = { stringValue: storeInfo.country };

    log('Tracking:', eventType, payload);

    var url = baseUrl + '/ab_events/' + docId + '?key=' + CONFIG.firebase.apiKey;
    var body = JSON.stringify(payload);

    // Use sendBeacon for events that fire right before navigation (checkout)
    // to ensure delivery even if the page unloads immediately
    if (eventType === 'checkout_initiated' && navigator.sendBeacon) {
      var blob = new Blob([body], { type: 'application/json' });
      var sent = navigator.sendBeacon(url, blob);
      log('sendBeacon checkout:', sent ? 'queued' : 'failed');
      if (!sent) {
        fetch(url, { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true }).catch(function(e) { log('Track error:', e); });
      }
    } else {
      fetch(url, { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: body }).catch(function(e) { log('Track error:', e); });
    }
  }

  // ── Parse /cart/add request body ──
  function parseCartAddBody(args) {
    var info = {};
    try {
      var opts = args[1];
      if (!opts || !opts.body) return info;
      var body = typeof opts.body === 'string' ? JSON.parse(opts.body) : null;
      if (!body && opts.body instanceof FormData) {
        body = {};
        opts.body.forEach(function(val, key) { body[key] = val; });
      }
      if (body) {
        if (body.id) info.shopifyVariantId = String(body.id);
        var kSid = body['properties[__kaching_session_id]']
          || (body.properties && body.properties.__kaching_session_id);
        if (kSid) info.kachingSessionId = kSid;
      }
    } catch(e) {}
    return info;
  }

  // ── Parse form data ──
  function parseCartAddForm(form) {
    var info = {};
    try {
      var fd = new FormData(form);
      var id = fd.get('id');
      if (id) info.shopifyVariantId = String(id);
      var kSid = fd.get('properties[__kaching_session_id]');
      if (kSid) info.kachingSessionId = kSid;
    } catch(e) {}
    return info;
  }

  // ── Setup tracking interceptors ──
  function setupTracking() {
    log('Setting up cart tracking...');

    // Use PerformanceObserver to detect /cart/add requests without wrapping fetch
    // (wrapping fetch conflicts with storefront-pixels.js and Kaching interceptors)
    try {
      var perfObserver = new PerformanceObserver(function(list) {
        list.getEntries().forEach(function(entry) {
          if (entry.initiatorType === 'fetch' && entry.name.indexOf('/cart/add') !== -1) {
            var productId = window.ShopifyAnalytics?.meta?.product?.id || 'unknown';
            if (!isDuplicateAtc(String(productId))) {
              log('Add-to-cart detected (perf observer)');
              var kachingInfo = getKachingInfo();
              var meta = Object.assign({ method: 'fetch' }, kachingInfo);
              trackEvent('add_to_cart', meta);
            }
          }
        });
      });
      perfObserver.observe({ type: 'resource', buffered: false });
    } catch(e) { log('PerformanceObserver not available, relying on form submit listener'); }

    document.addEventListener('submit', function(e) {
      try {
        if (e.target.action && e.target.action.indexOf('/cart/add') !== -1) {
          var productId = window.ShopifyAnalytics?.meta?.product?.id || 'unknown';
          if (!isDuplicateAtc(String(productId))) {
            log('Add-to-cart detected (form)');
            var cartData = parseCartAddForm(e.target);
            var kachingInfo = getKachingInfo();
            var meta = Object.assign({ method: 'form' }, cartData, kachingInfo);
            trackEvent('add_to_cart', meta);
          }
        }
      } catch(e2) { log('ATC form intercept error:', e2); }
    });

    // ── Checkout button intercept ──
    // The checkout button (#checkout, name=checkout) triggers a redirect to external checkout.
    // Listen for clicks on it and on any link/form pointing to /checkout.
    document.addEventListener('click', function(e) {
      try {
        var target = e.target.closest('#checkout, [name="checkout"], a[href*="/checkout"], .cart__checkout-button');
        if (target) {
          log('Checkout initiated');
          var kachingInfo = getKachingInfo();
          trackEvent('checkout_initiated', kachingInfo);
        }
      } catch(e2) { log('Checkout intercept error:', e2); }
    });

    // Also intercept form submissions to /checkout
    document.addEventListener('submit', function(e) {
      try {
        if (e.target.action && e.target.action.indexOf('/checkout') !== -1) {
          log('Checkout initiated (form)');
          var kachingInfo = getKachingInfo();
          trackEvent('checkout_initiated', kachingInfo);
        }
      } catch(e2) {}
    });

    log('Cart tracking ready');
  }

  window.trackABEvent = trackEvent;

  // ── Delayed page_view with Kaching data ──
  // Kaching loads async, so fire a supplemental page_view once Kaching is ready.
  function waitForKachingAndTrack() {
    var attempts = 0;
    var maxAttempts = 20; // 20 x 500ms = 10 seconds max
    var interval = setInterval(function() {
      attempts++;
      var block = document.querySelector('.kaching-bundles__block--loaded, [data-deal-block-id]');
      if (block || attempts >= maxAttempts) {
        clearInterval(interval);
        if (block) {
          var kachingInfo = getKachingInfo();
          log('Kaching loaded, sending enriched page_view', kachingInfo);
          trackEvent('page_view_enriched', kachingInfo);
        }
      }
    }, 500);
  }

  function init() {
    setupTracking();
    log('Page view');
    trackEvent('page_view', {
      referrer: document.referrer || 'direct',
      path: window.location.pathname
    });
    // Wait for Kaching to load and send enriched page view with offer data
    waitForKachingAndTrack();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
